export default "__VITE_ASSET__a1cf5c45__"